(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/play-next-draw-dialog.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/play-next-draw-dialog.js');

'use strict';

const formatTime = svs.utils.date.FormatTime;

function playNextDrawDialog(_ref) {
  let {
    next,
    cancel,
    regCloseTime
  } = _ref;
  const title = 'Dagens spel är stängt';
  const message = "Du deltar i n\xE4sta dragning ".concat(formatTime('eeee d/M', regCloseTime), ".");
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: message
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Fortsätt',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
function shouldShowPlayNextDrawDialog(_ref2) {
  let {
    params,
    calls
  } = _ref2;
  return () => {
    const {
      primaryDraw,
      secondaryDraw,
      wagers
    } = params();
    const drawOpenedToday = dateFns.isToday(new Date(primaryDraw.regOpenTime)) || dateFns.isToday(new Date(secondaryDraw.regOpenTime));
    const skipDialog = wagers.some(_ref3 => {
      let {
        lastDrawDate
      } = _ref3;
      return lastDrawDate && dateFns.isToday(new Date(lastDrawDate));
    });

    if (drawOpenedToday && !skipDialog) {
      return {
        calls: calls()
      };
    }
  };
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  playNextDrawDialog,
  shouldShowPlayNextDrawDialog
});

 })(window);